import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2yyd2d2xy: FaireProductEntity = {
  token: "p_n2yyd2d2xy",
  type: "product",
  name: "Build Your Own Frozen Cocktail Display Package",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/741437c2d16e0a249637530bdc88875c2d5ab60ba8eeaa3af7313e370e075487.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c03290b49b0d8e49768a0704b2ad4619e40e25aa81ceb90c3ad8b6f277fdad8c.png",
    "https://cdn.faire.com/fastly/8c403bbfe4c37ceff0cb53fc9ddc2e5f93a6131e13f09ec526562c6b76779665.jpeg",
    "https://cdn.faire.com/fastly/056bd0e836db09e85cd6e60513d3168933b94c4961ea9111be8cbca5cfab543e.png",
    "https://cdn.faire.com/fastly/80268d1da36896da0f0709bc9a59390940792bdb122d1a7a7b543c7106941f0b.png",
    "https://cdn.faire.com/fastly/23a3254c99d97a0972b32dc8569ac2a7719449b646f96f5a12fa1f02cda28cb7.jpeg",
    "https://cdn.faire.com/fastly/234e676cf00ddb796e35abc0be3ab320495f05dd8135187926509d5b2e63a45a.png",
    "https://cdn.faire.com/fastly/371b0d7d7c5e266f85a7cfc932f8969d7f99f11a8bafc0c97664d4b11cdf9a5d.jpeg",
    "https://cdn.faire.com/fastly/49c56f36943faefcc27a562a72cd65fdd0ea24b6eef5be4f92e8a5ab891c0b91.png",
    "https://cdn.faire.com/fastly/d2dffc564e343471efb0178026a4b6c2b5e9500a0660e2ce99fe8cbea1557546.jpeg",
    "https://cdn.faire.com/fastly/74ef1cadec46afbbda7576cd7ff77b057e718652b019fb9a838073020dd69fc5.png",
    "https://cdn.faire.com/fastly/e1f814e569a01a49e3dff7897a38b13768e2bf4b39bfef8ec35a05741cead042.jpeg",
    "https://cdn.faire.com/fastly/b73465f5f4c8f3837b2ea3ad5dffbbcbcce49b5bd4258744ffc21b3d66c69b97.png",
    "https://cdn.faire.com/fastly/b1b4f00aee3cf041e33ce910bbd462f605e94b0c9d9d289aeaaf9b5eb2930d0e.png",
    "https://cdn.faire.com/fastly/d34c35fe8e894110ec2d819c54989790f381736c7f9bc2fd34f87c6870555e41.png",
    "https://cdn.faire.com/fastly/f8a900033a1ce6202899ed66909b86c6f584aeb9e4476b144783386edcaa8cea.png",
    "https://cdn.faire.com/fastly/791f884368926b2c9dece1e2ad3bc27d7bf7d34f887d8535d3a33095daefd120.png",
  ],
  priceDollars: 612,
  description:
    'Please choose 6 of the following flavors: \n\nMargarita, Espresso Martini, Peach Bellini, Limoncello, Pina Colada, Orange Creamsicle, Frose, Sangria, Strawberry Daiquiri, Grapefruit Crush, Mudslide, Pink Flamingo, French Blonde, Beehive Bellini, Meyer Lemon Fizz, Island Punch, Bourbon Brownie, Grasshopper, White Russian, Java Cream, Vanilla Bean\n\nPlease send us a message after submitting your order of which 6 flavors you\'d like included! - We will choose for you if we do not receive a response to the attempts to contact you.\n\nA full table top display package. Includes 12 each of 6 frozen cocktails of your choice.\n\n(72 total packs - cost $8.50 each) Includes a FREE display. 27"wide x 24"tall x 10"deep \n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!\n',
  tags: [],
  msrpDollars: 1224,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:06.609Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
